// Getter
export const GETTERS_INCENTIVE_TEMPLATES = "GETTERS_INCENTIVE_TEMPLATES";
export const GETTERS_INCENTIVE_FILES = "GETTERS_INCENTIVE_FILES";

// action
export const ACTION_GET_INCENTIVE_TEMPLATES = "ACTION_GET_INCENTIVE_TEMPLATES";
export const ACTION_DOWNLOAD_INCENTIVE_TEMPLATE = "ACTION_DOWNLOAD_INCENTIVE_TEMPLATE";
export const ACTION_UPLOAD_INCENTIVE_FILE = "ACTION_UPLOAD_INCENTIVE_FILE";
export const ACTION_PROCESS_INCENTIVE_FILE = "ACTION_PROCESS_INCENTIVE_FILE";
export const ACTION_GET_INCENTIVE_FILES = "ACTION_GET_INCENTIVE_FILES";
export const ACTION_DOWNLOAD_INCENTIVE_FILE = "ACTION_DOWNLOAD_INCENTIVE_FILE";
export const ACTION_DOWNLOAD_INCENTIVE_PROCESSING_REPORT = "ACTION_DOWNLOAD_INCENTIVE_PROCESSING_REPORT";

// Mutation
export const MUTATION_SET_INCENTIVE_TEMPLATES = "MUTATION_SET_INCENTIVE_TEMPLATES";
export const MUTATION_SET_INCENTIVE_FILES = "MUTATION_SET_INCENTIVE_FILES";



// WEBPACK FOOTER //
// ./src/store/modules/incentive_processing/constants.js